export interface AdvancedSettings {
  xMin: number;
  xMax: number;
  yMin: number;
  yMax: number;
  height: number;
  width: number;
  aspectRatio: string;
}

export class AdvancedSettings {
  xMin: number;
  xMax: number;
  yMin: number;
  yMax: number;
  height: number;
  width: number;
  aspectRatio: string;

  constructor(xMin: number, xMax: number, yMin: number, yMax: number, height: number, width: number, aspectRatio: string) {
    this.xMin = xMin,
    this.xMax = xMax,
    this.yMin = yMin,
    this.yMax = yMax,
    this.height = height,
    this.width = width,
    this.aspectRatio = aspectRatio
  }
}
